import React, { useEffect, useState } from 'react';
import { useOpenAriMutation } from '../../api/ari';

interface WindowsARIPlayerProps {
  completeUrl: string;
  resId: string;
  bookId: string;
}

const WindowsARIPlayer: React.FC<WindowsARIPlayerProps> = ({ completeUrl, bookId, resId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [openAri, { isLoading: isAriLoading, isError: isAriError }] = useOpenAriMutation();

  useEffect(() => {
    const openARIPlayer = async () => {
      try {
        const url = new URL(completeUrl, process.env.REACT_APP_API_SERVER_URL);
        const manifest = url.searchParams.get('manifest');
        const jumpoff = url.searchParams.get('jumpoff');
        const urlParam = url.searchParams.get('url');

        if (!manifest) {
          throw "Error while opening model"
        }

        await openAri({
          bookId: bookId,
          resourceId: resId,
          manifest,
          jumpOffPoint: jumpoff,
          analyticsUrl: urlParam,
        }).unwrap();

        setIsLoading(false);
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError('An unknown error occurred');
        }
        setIsLoading(false);
      }
    };

    openARIPlayer();
  }, [bookId, completeUrl, resId, openAri]);

  return (
    <div className="min-h-[200px] h-full flex items-center justify-center bg-gray-50 p-8 rounded-lg shadow-sm">
      {isLoading ? (
        <div className="text-center">
          <div className="mb-4">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-300 border-t-blue-600"></div>
          </div>
          <h2 className="text-xl font-semibold text-gray-800">
            Opening ARI model in the windows player. Please wait.
          </h2>
          <p className="mt-2 text-gray-600">
            Please wait while we prepare your content
          </p>
        </div>
      ) : error ? (
        <div className="text-center text-red-600">
          <p className="text-lg font-medium">Error opening ARI player</p>
          <p className="mt-2 text-sm">{error}</p>
        </div>
      ) : (
        <div className="text-center text-green-600">
          <p className="text-lg font-medium">ARI player opened successfully</p>
        </div>
      )}
    </div>
  );
};

export default WindowsARIPlayer;
